module.exports = __webpack_public_path__ + "static/img/5.c73f16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/5.png
// module id = 0nbw
// module chunks = 0